export interface FuseConfirmationConfig {
    title?: string;
    message?: string;
    icon?: {
        show?: boolean;
        name?: string;
        color?:
            | 'primary'
            | 'accent'
            | 'warn'
            | 'basic'
            | 'info'
            | 'success'
            | 'warning'
            | 'error';
    };
    actions?: {
        confirm?: {
            show?: boolean;
            label?: string;
            color?: 'primary' | 'accent' | 'warn';
        };
        cancel?: {
            show?: boolean;
            label?: string;
        };
    };
    dismissible?: boolean;
    showDatePicker?: boolean;
    selectedDate?: Date;
    showAmount?: boolean;
    amount?: number;
    calculateAmount?: (date: Date) => number;
}

/**
 * Default configuration for the confirmation dialog
 */
export const FuseConfirmationDefaultConfig: FuseConfirmationConfig = {
    title: 'Confirm action',
    message: 'Are you sure you want to confirm this action?',
    icon: {
        show: true,
        name: 'warning',
        color: 'warn',
    },
    actions: {
        confirm: {
            show: true,
            label: 'Confirm',
            color: 'warn',
        },
        cancel: {
            show: true,
            label: 'Cancel',
        },
    },
    dismissible: false,
    showDatePicker: false,
    selectedDate: undefined,
    showAmount: false,
    amount: 0,
    calculateAmount: undefined
};
